import styled from "styled-components";
import { getTheme, Flow, Button, Loader, Text as Tx, } from "@bracket/ui";
import { useWallet, } from "@bracket/platform/store";

import type { FunctionComponent, } from "react";

import { formatWEI,} from "@formatters";



/**
 * ClaimBar component displays a claim notification bar when user has a claim available
 * @param props - The component props
 * @param props.amount - The claim amount as bigint
 * @param props.claimable - Boolean indicating if user has a claim available
 * @returns JSX.Element - The ClaimBar component
 */
export const ClaimBar: FunctionComponent = () => {

	const { ready, claim_amount, has_claim, claimEscrow, claiming, } = useWallet();

	if(!ready || !has_claim) {
		return null;
	}

	if(claiming) {
		return (
			<ClaimBarContainer>
				<Loader center />
			</ClaimBarContainer>
		)
	}

	return (
		<ClaimBarContainer>
			<Tx color="surface_on" weight="500">You have a claim available: {formatWEI(claim_amount, 18, 5)} brktETH</Tx>
			<Button label="Claim Now" onClick={claimEscrow} />
		</ClaimBarContainer>
	);
};


const ClaimBarContainer = styled(Flow)`
	align-items: center;
	gap: 1rem;
	justify-content: center;
	background-color: ${() => getTheme().background};
	border-radius: ${() => getTheme().radials.sm};
	margin-bottom: 16px;
	padding: 1rem;
	p, span {
		color: ${() => getTheme().surface_on};
	}
`;
